module.exports = __webpack_public_path__ + "img/04_kii_02.77963746.jpg";